"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_1 = __importDefault(require("@mui/material/Card"));
var CardActionArea_1 = __importDefault(require("@mui/material/CardActionArea"));
var CardMedia_1 = __importDefault(require("@mui/material/CardMedia"));
var CardContent_1 = __importDefault(require("@mui/material/CardContent"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var PLACEHOLDER_SVG = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='300' viewBox='0 0 200 300'><rect width='200' height='300' fill='%23e8e0f0'/><text x='100' y='150' text-anchor='middle' fill='%235E309F' font-size='14' font-family='sans-serif'>No cover</text></svg>";
var BookCard = function (_a) {
    var _b, _c;
    var book = _a.book;
    return (react_1.default.createElement(Card_1.default, { sx: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid rgba(0,0,0,0.08)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 6,
            },
        } },
        react_1.default.createElement(CardActionArea_1.default, { href: "/app/books/".concat(book.slug), sx: { flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' } },
            react_1.default.createElement(CardMedia_1.default, { component: "img", image: (_c = (_b = book.thumb_url) !== null && _b !== void 0 ? _b : book.cover_image_url) !== null && _c !== void 0 ? _c : PLACEHOLDER_SVG, alt: book.title, loading: "lazy", sx: { aspectRatio: '2/3', objectFit: 'cover', objectPosition: 'top', width: '100%' } }),
            react_1.default.createElement(CardContent_1.default, { sx: { flexGrow: 1 } },
                react_1.default.createElement(Typography_1.default, { variant: "subtitle2", fontWeight: 600, gutterBottom: true, sx: {
                        lineHeight: 1.3,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                    } }, book.title),
                book.author && (react_1.default.createElement(Typography_1.default, { variant: "caption", color: "text.secondary", display: "block" }, book.author))))));
};
exports.default = BookCard;
